import { render, staticRenderFns } from "./BS_dataAccount.vue?vue&type=template&id=47ef4ce8&scoped=true&"
import script from "./BS_dataAccount.vue?vue&type=script&lang=js&"
export * from "./BS_dataAccount.vue?vue&type=script&lang=js&"
import style0 from "./BS_dataAccount.vue?vue&type=style&index=0&id=47ef4ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ef4ce8",
  null
  
)

export default component.exports